import { CLEAR_ALL_POST, HIDE_MODAL_POST, SET_ALL_POST, SET_NEW_POST, SHOW_MODAL_POST } from "../constants";
const initialState = {
    showModal: false,
    newPost:'',
    allPost:[]

}

function searchPlayer(state = initialState, action) {
switch (action.type) {
    case SHOW_MODAL_POST:
        return {...state, showModal: true };
    case HIDE_MODAL_POST:
        return {...state, showModal: false};
    case SET_ALL_POST:
        return {...state, allPost: action.payload};
    case SET_NEW_POST:
        return {...state, newPost: action.payload};
    case CLEAR_ALL_POST:
        return initialState
    default:
        return state;
}

}

export default searchPlayer